import { getHasFilesToShow } from '../../../../../utils/file'
import { useAttachStorageFiles, useFileUpload } from '../../../../File'
import { useChatroomInputAttach } from '../../../ChatroomInputForm'

import { isChatroomMessageEditStorageFile } from './useChatroomMessageEditFiles.utils'

export function useChatroomMessageEditFiles({
  files,
  outboundUuid,
  storageFiles,
  onCloseModal,
  onSetFiles,
  onSetModal,
  onSetStorageFiles,
}) {
  const {
    filesError,
    filesUploading,
    handleRemoveFile,
    handleStartUploading,
    handleUploadErrors,
    handleUploadFile,
  } = useFileUpload({ files, outboundUuid, onSetFiles })

  const { handleAddStorageFile, handleRemoveStorageFile } =
    useAttachStorageFiles({ onSetFiles: onSetStorageFiles })

  const { attachActionOptions, handleAttachAction } = useChatroomInputAttach({
    outboundUuid,
    selectedStorageFiles: storageFiles,
    onAttachFilesFromStorage: handleAddStorageFile,
    onCloseModal,
    onSetModal,
  })

  function handleRemoveFileTag(file) {
    if (isChatroomMessageEditStorageFile({ file, storageFiles })) {
      handleRemoveStorageFile(file.id)
    } else {
      handleRemoveFile(file.id)
    }
  }

  const allFiles = [...storageFiles, ...files]

  const showFiles = getHasFilesToShow({
    files: allFiles,
    filesError,
    filesUploading,
  })

  return {
    allFiles,
    attachActionOptions,
    filesError,
    filesUploading,
    handleAttachAction,
    handleRemoveFileTag,
    handleStartUploading,
    handleUploadErrors,
    handleUploadFile,
    showFiles,
  }
}
